// Reload the app when a new version has been deployed and files are missing

const lastReloadLsKey = 'loadErrorHandler:lastReload';
const reloadMinInterval = 30 * 1000;

export function handleLoadError() {
  const lastReloadString = localStorage.getItem(lastReloadLsKey);
  const lastReloadDate = lastReloadString ? new Date(lastReloadString) : null;
  if (
    lastReloadDate &&
    Date.now() - lastReloadDate.getTime() < reloadMinInterval
  ) {
    return;
  }
  localStorage.setItem(lastReloadLsKey, new Date().toISOString());

  window.alert(
    'A new version of the app has been released. The page will now reload.',
  );

  window.location.reload();
}

// https://vitejs.dev/guide/build#load-error-handling
window.addEventListener('vite:preloadError', handleLoadError);
